export default "__VITE_ASSET__n5dKDb8X__"